import { compareDesc } from "date-fns";


export function byDateDesc<T>(fn: (x: T) => Date | string): (a: T, b: T) => number {
  return (a: T, b: T) => compareDesc(new Date(fn(a)), new Date(fn(b)));
}
